export interface MapRouteSelectionParams {
  pos?: unknown;
  location?: unknown;
}

const hasNonEmptyStringValue = (value: unknown): value is string =>
  typeof value === 'string' && value.trim().length > 0;

export const hasMapRouteSelection = (params?: MapRouteSelectionParams): boolean =>
  hasNonEmptyStringValue(params?.pos) && hasNonEmptyStringValue(params?.location);

export const shouldClearMapSelectionForReset = (
  resetMap: boolean,
  params?: MapRouteSelectionParams,
): boolean => resetMap && !hasMapRouteSelection(params);

/** Keep an open drawer stable while its reserved listing leaves discovery. */
export function getRetainedMapMissionDetail<T>(
  cached: { branchId: string; accountId?: string; mission: T } | undefined,
  branchId?: string,
  accountId?: string,
): T | undefined {
  return branchId && cached && cached.branchId === branchId && cached.accountId === accountId ? cached.mission : undefined;
}
